import React, { useContext, useEffect, useState, useMemo } from "react";
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";
import { fetchCouponPopupBalanceDataPVIN } from "./PvinKip";
import { FilterContext } from "../../context/Filter";

const BalancedTataCareCuponTable = () => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [balancedCuponData, setBalancedCuponData] = useState([]);

  const fetchBalancedData = async () => {
    try {
      const response = await fetchCouponPopupBalanceDataPVIN(parArn, childArn);

      // Format response
      const formattedData =
        response?.map((item) => ({
          chassisNo: item.chassis_no || "-",
          balancedCupon: item.total_amount_coupon_balance || 0,
        })) || [];

      setBalancedCuponData(formattedData);
    } catch (error) {
      console.error("Error fetching balanced cupon data:", error);
    }
  };

  useEffect(() => {
    if (parArn || childArn) {
      fetchBalancedData();
    }
  }, [parArn, childArn]);

  // Define table columns
  const columns = useMemo(
    () => [
      {
        header: "Chassis No.",
        accessorKey: "chassisNo",
      },
      {
        header: "Balanced Tata Care Cupon",
        accessorKey: "balancedCupon",
      },
    ],
    []
  );

  const table = useReactTable({
    data: balancedCuponData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-2">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg text-sm text-center">
          {/* Table Header */}
          <thead className="bg-[#1467B3] text-white">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border-b px-4 py-2 font-semibold text-center"
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {/* Table Body */}
          <tbody>
            {table.getRowModel().rows.length > 0 ? (
              table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className="border-b px-4 py-2 text-center">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-4 text-gray-500"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BalancedTataCareCuponTable;
